import { PaperclipIcon } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import type { EventFileListProps } from '@/lib/types/event-files.types';
import { formatEventFileSize } from '@/lib/utils/event-files.utils';

export function EventMaterialsList({
  files,
  isLoading = false,
  isOpeningId = null,
  onOpenFile,
}: EventFileListProps) {
  if (isLoading) {
    return (
      <div className="py-6" data-testid="event-materials-section">
        <h2 className="mb-4 font-field-54 text-h2 text-purple-300">
          Materials
        </h2>
        <p className="text-body text-slate-300">Loading materials...</p>
      </div>
    );
  }

  if (files.length === 0) {
    return null;
  }

  return (
    <section className="py-6" data-testid="event-materials-section">
      <h2 className="mb-4 font-field-54 text-h2 text-purple-300">Materials</h2>
      <div className="space-y-3">
        {files.map((file) => (
          <Button
            key={file.id}
            type="button"
            variant="ghost"
            className="flex h-auto w-full items-center justify-start gap-3 rounded-md border border-slate-500 bg-slate-700 p-4 text-left text-slate-50 hover:bg-slate-500 [&_svg]:size-7"
            onClick={() => onOpenFile(file)}
            disabled={isOpeningId === file.id}
            data-testid="event-material-link"
          >
            <PaperclipIcon
              className="flex-shrink-0 text-red-300"
              weight="fill"
            />
            <span className="min-w-0 flex-1">
              <span className="block truncate text-body font-semibold">
                {file.display_title}
              </span>
              <span className="block text-small text-slate-300">
                {formatEventFileSize(file.size_bytes)}
              </span>
            </span>
          </Button>
        ))}
      </div>
    </section>
  );
}
